module.exports = __webpack_public_path__ + "img/taoyuan-5.beb71230.jpg";